(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-lp-review-stars"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tdLpReviewPopupBound) return;
    window.__tdLpReviewPopupBound = true;

    function triggerClick(element) {
      if (!element) return false;
      if (typeof element.click === 'function') {
        element.click();
        return true;
      }
      element.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
      return true;
    }

    function openFromFloatingToggler() {
      var selectors = [
        '.loox-float-toggler-container button',
        ".loox-float-toggler-container [role='button']",
        '.loox-float-toggler-container .loox-float-toggler',
        '.loox-float-toggler-container'
      ];

      for (var i = 0; i < selectors.length; i++) {
        var toggler = document.querySelector(selectors[i]);
        if (toggler && triggerClick(toggler)) return true;
      }

      return false;
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lp-review-popup-trigger]');
      if (!trigger) return;

      event.preventDefault();
      var proxyId = trigger.getAttribute('data-lp-review-popup-trigger');
      if (!proxyId) return;

      var proxy = document.querySelector('[data-lp-review-proxy="' + proxyId + '"]');
      if (proxy && triggerClick(proxy)) return;

      openFromFloatingToggler();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
